import React from "react";
import BootstrapTable from "@partseye/react-bootstrap-table-next";
import "@partseye/react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "@partseye/react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css";

function InternalOnlyInfo (props) {

    const basicColumns = [
            {"dataField": "groupCode",
            "text": props.pageText.groupCode,
            style: { textAlign: 'left' }
        },
            {"dataField": "forecastStatus",
            "text": props.pageText.forecastStatus,
                style: { textAlign: 'left' }
        },
            {"dataField": "stockingMinimum",
                "text": props.pageText.manualStockingMin,
            "formatter": (val) => (val ? val : props.pageText.na),
                style: { textAlign: 'left' }
        },
            {"dataField": "stockingMaximum",
                "text": props.pageText.manualStockingMax,
            "formatter": (val) => (val ? val : props.pageText.na),
                style: { textAlign: 'left' }
        },
            {"dataField": "maxStockLevel",
                "text": props.pageText.dealerMaxStock,
                "formatter": (val) => (val ? val : props.pageText.na),
                style: { textAlign: 'left' }
            }
        ],

        planningParametersColumns = [
            {"dataField": "dealerCode",
                "text": props.pageText.basicDealerCode,
                style: { textAlign: 'left' }
            },
            {"dataField": "partNumber",
                "text": props.pageText.sku,
                style: { textAlign: 'left' }
            },
            {"dataField": "partType",
                "text": props.pageText.partType,
                style: { textAlign: 'left' }
            },
            {"dataField": "leadTime",
                "text": props.pageText.leadTime,
                style: { textAlign: 'left' }
            },
            {"dataField": "safetyStock",
                "text": props.pageText.safetyStock,
                style: { textAlign: 'left' }
            },
            {"dataField": "pI1Months",
                "text": props.pageText.pi1M,
                style: { textAlign: 'left' }
            },
            {"dataField": "pI1MonthsUnique",
                "text": props.pageText.pi1MU,
                style: { textAlign: 'left' }
            },
            {"dataField": "pI1TotalDemands",
                "text": props.pageText.pi1D,
                style: { textAlign: 'left' }
            },
            {"dataField": "pI2Months",
                "text": props.pageText.pi2M,
                style: { textAlign: 'left' }
            },
            {"dataField": "pI2MonthsUnique",
                "text": props.pageText.pi2MU,
                style: { textAlign: 'left' }
            },
            {"dataField": "pI2TotalDemands",
                "text": props.pageText.pi2D,
                style: { textAlign: 'left' }
            },
            {"dataField": "pieMonths",
                "text": props.pageText.piEM,
                style: { textAlign: 'left' }
            },
            {"dataField": "pieMonthUnique",
                "text": props.pageText.piEMU,
                style: { textAlign: 'left' }
            },
            {"dataField": "pieTotalDemands",
                "text": props.pageText.piED,
                style: { textAlign: 'left' }
            },
            {"dataField": "notes",
                "text": props.pageText.notes,
                style: {
                    textAlign: 'left',
                    clear: 'both',
                    display: 'inline - block',
                    overFlow: 'hidden',
                }
            }
        ],

        planningDaysColumns = [
            {"dataField": "dealerCode",
                "text": props.pageText.basicDealerCode,
                style: { textAlign: 'left' }
            },
            {"dataField": "partNumber",
                "text": props.pageText.sku,
                style: { textAlign: 'left' }
            },
            {"dataField": "lowSales",
                "text": props.pageText.lowSales,
                "formatter": (val) => val.toFixed(2),
                style: { textAlign: 'left' }
            },
            {"dataField": "partType",
                "text": props.pageText.partType,
                style: { textAlign: 'left' }
            },
            {"dataField": "daysRop",
                "text": props.pageText.daysRop,
                "formatter": (val) => val.toFixed(2),
                style: { textAlign: 'left' }
            },
            {"dataField": "daysStockMax",
                "text": props.pageText.daysStockMax,
                style: { textAlign: 'left' }
            },
            {"dataField": "notes",
                "text":  props.pageText.notes,
                style: {
                    textAlign: 'left',
                    clear: 'both',
                    display: 'inline - block',
                    overFlow: 'hidden'
                }
            }
        ],

        basicData = [],
        paramData = [],
        daysData = [];

    if (props.partInfo) {

        basicData.push(props.partInfo);

    }
    if (props.planningParameters) {

        paramData.push(props.planningParameters);

    }
    if (props.planningDays) {

        daysData.push(props.planningDays);

    }

    return (
        <div className="basic-info internal-info container-fluid">
            <h5 className="basic-info-title title">
                {props.pageText.internalTitle}
            </h5>
            <div className="basic-info-content">
                <BootstrapTable
                    bootstrap4
                    columns={basicColumns}
                    condensed
                    data={basicData}
                    headerClasses="thead-light"
                    id="basicTable"
                    keyField="groupCode"
                />
                <p className="data-header" id="planningPara">
                    {props.pageText.planningParams}
                </p>
                <BootstrapTable
                    bootstrap4
                    columns={planningParametersColumns}
                    condensed
                    data={paramData}
                    headerClasses="thead-light"
                    id="paramTable"
                    keyField="partNumber"
                />
                <p className="data-header" id="planningDays">
                    {props.pageText.planningDays}
                </p>
                <BootstrapTable
                    bootstrap4
                    columns={planningDaysColumns}
                    condensed
                    data={daysData}
                    headerClasses="thead-light"
                    id="daysTable"
                    keyField="partNumber"
                />
            </div>
        </div>
    );

}

export default InternalOnlyInfo;
